import type React from "react";

export function SectionHeader({
  label,
  title,
  description,
  align = "left",
  inverse = false,
}: {
  label: string;
  title: string;
  description: string;
  align?: "left" | "center";
  inverse?: boolean;
}) {
  return (
    <div className={`${align === "center" ? "mx-auto text-center" : ""} max-w-2xl`}>
      <div className={`mb-3 font-mono text-xs font-semibold uppercase ${inverse ? "text-action-primary-border" : "text-primary-ink"}`}>
        {label}
      </div>
      <h2 className={`font-display text-4xl font-bold leading-[1.08] tracking-normal sm:text-5xl ${inverse ? "text-bg-page dark:text-text-primary" : "text-text-primary"}`}>
        {title}
      </h2>
      <p className={`mt-5 text-base leading-7 ${inverse ? "text-bg-page/75 dark:text-text-secondary" : "text-text-secondary"}`}>
        {description}
      </p>
    </div>
  );
}

export function Metric({ value, label }: { value: string; label: string }) {
  return (
    <div className="border-l border-border-subtle pl-4 first:border-l-0 first:pl-0">
      <div className="font-display text-2xl font-semibold leading-tight text-text-primary">{value}</div>
      <div className="mt-1 text-xs leading-5 text-text-muted">{label}</div>
    </div>
  );
}

export function CardIcon({
  icon: Icon,
  className = "bg-primary-soft text-primary-ink",
}: {
  icon: React.ComponentType<{ className?: string }>;
  className?: string;
}) {
  return (
    <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${className}`}>
      <Icon className="h-5 w-5" />
    </div>
  );
}

export function Kicker({
  children,
  className = "text-primary-ink",
  dotClassName = "bg-action-primary",
}: {
  children: React.ReactNode;
  className?: string;
  dotClassName?: string;
}) {
  return (
    <div className={`inline-flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-normal ${className}`}>
      <span aria-hidden="true" className={`h-2 w-2 rounded-full ${dotClassName}`} />
      {children}
    </div>
  );
}
